/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Formulas_NoteInputs */

const en_gc_resources_guide_formulas_note = /** @type {(inputs: Gc_Resources_Guide_Formulas_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with simple formulas and verify the result. Some Excel functions and advanced workbook features are not supported in the alpha.`)
};

const zh_gc_resources_guide_formulas_note = /** @type {(inputs: Gc_Resources_Guide_Formulas_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先尝试简单公式并验证结果。Alpha 版本尚不支持所有 Excel 函数与高级工作簿功能。`)
};

/**
* | output |
* | --- |
* | "Start with simple formulas and verify the result. Some Excel functions and advanced workbook features are not supported in the alpha." |
*
* @param {Gc_Resources_Guide_Formulas_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_formulas_note = /** @type {((inputs?: Gc_Resources_Guide_Formulas_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Formulas_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_formulas_note(inputs)
	return zh_gc_resources_guide_formulas_note(inputs)
});
export { gc_resources_guide_formulas_note as "gc.resources.guide.formulas.note" }